export default {
  API_URL: process.env.REACT_APP_API_URL || '',
  MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY || '',
  IS_DEV: process.env.NODE_ENV === 'development',
  PUSHER_APP_ID: process.env.REACT_APP_PUSHER_APP_ID || '',
  PUSHER_KEY: process.env.REACT_APP_PUSHER_KEY || '',
  PUSHER_SECRET: process.env.REACT_APP_PUSHER_SECRET || '',
  PUSHER_CLUSTER: process.env.REACT_APP_PUSHER_CLUSTER || '',
}
